/**
 * 报名状态页面 - 重构版
 * 显示用户提交的报名信息和审核状态
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useRegistrationStore, useAuthStore } from '../stores';
import { statusTextMap } from '../types';

const Status: React.FC = () => {
  const { registration, formData } = useRegistrationStore();
  const { user } = useAuthStore();

  // 状态样式映射
  const statusStyles = {
    pending: { bg: 'bg-amber-100', text: 'text-amber-700', icon: '⏳' },
    approved: { bg: 'bg-emerald-100', text: 'text-emerald-700', icon: '✓' },
    rejected: { bg: 'bg-red-100', text: 'text-red-700', icon: '✕' },
  };

  const status = registration?.status || 'pending';
  const style = statusStyles[status];

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-10 text-center animate-in zoom-in duration-300">
        {/* 成功图标 */}
        <div className={`w-20 h-20 ${style.bg} ${style.text} rounded-full flex items-center justify-center mx-auto mb-8 text-4xl`}>
          {style.icon}
        </div>

        <h1 className="text-2xl font-bold text-slate-800 mb-4">报名资料提交成功</h1>

        {/* 状态标签 */}
        <div className={`inline-block px-3 py-1 ${style.bg} ${style.text} text-xs font-bold rounded-full mb-6`}>
          {statusTextMap[status]}
        </div>

        {/* 报名信息摘要 */}
        {(registration || formData) && (
          <div className="bg-slate-50 rounded-xl p-4 mb-6 text-left">
            <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">报名信息</h3>
            <div className="space-y-2 text-sm">
              {registration?.id && (
                <div className="flex justify-between">
                  <span className="text-slate-500">报名编号</span>
                  <span className="font-mono font-bold text-blue-600">{registration.id}</span>
                </div>
              )}
              <div className="flex justify-between">
                <span className="text-slate-500">学生姓名</span>
                <span className="font-bold">{registration?.studentName || formData?.studentName || user?.studentName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-500">学段</span>
                <span>{registration?.studentLevel || formData?.studentLevel}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-500">学校</span>
                <span className="text-right max-w-[180px] truncate">{registration?.studentSchool || formData?.studentSchool}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-500">指导教师</span>
                <span>{registration?.mentorName || formData?.mentorName}</span>
              </div>
              {(registration?.teamMembers || formData?.teamMembers) && (
                <div className="flex justify-between">
                  <span className="text-slate-500">其他成员</span>
                  <span className="text-right max-w-[180px]">{registration?.teamMembers || formData?.teamMembers}</span>
                </div>
              )}
            </div>
          </div>
        )}

        <p className="text-slate-600 mb-8 leading-relaxed">
          您的报名信息已录入系统，目前正在人工审核中。
          请保持电话畅通，我们将在 <span className="text-blue-600 font-bold">3个工作日内</span> 通过短信或电话通知您审核结果。
        </p>

        <div className="space-y-3">
          <Link to="/" className="block w-full py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-all">
            返回首页
          </Link>
          <p className="text-xs text-slate-400">如有疑问，请咨询苏州市人工智能教育创新中心</p>
        </div>
      </div>
    </div>
  );
};

export default Status;
